<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <b-form-group label-cols="3" horizontal label="시간대 명칭">
          <b-input-group size="sm">
            <b-form-input v-model="settingValue.title"></b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group label-cols="3" horizontal label="시간대 운영 기간">

          <b-row align-v="center" class="mb-3 justify-content-start" no-gutters>
            <b-col md="auto">
              <!--              <b-form-checkbox v-model="always" :checked="true" :unchecked-value="false">상시운영</b-form-checkbox>-->
              <b-form-radio-group v-model="always">
                <b-form-radio value="true">상시운영</b-form-radio>
                <b-form-radio value="false">기간설정</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>


<!--          <b-row v-if='!this.always' align-v="center" class="justify-content-start" no-gutters>-->
          <b-row  align-v="center" class="justify-content-start" v-if="always == 'false' ">

            <b-col md="auto">
              <div class="form-group has-float-label">
                <v-date-picker
                  mode="single"
                  v-model="settingValue.startDate"
                  :input-props="{ class:'form-control', placeholder: $t('date.start-date') }"></v-date-picker>
                <span>{{ $t('date.start-date') }}</span>
              </div>
            </b-col>


            <b-col md="auto" class="ml-2">
              <span>~</span>
            </b-col>

            <b-col md="auto" class="ml-2">
              <div class="form-group has-float-label">
                <v-date-picker
                  mode="single"
                  v-model="settingValue.endDate"
                  :input-props="{ class:'form-control', placeholder: $t('date.end-date') }"></v-date-picker>
                <span>{{ $t('date.end-date') }}</span>
              </div>

            </b-col>

          </b-row>


        </b-form-group>

        <b-form-group label-cols="3" horizontal label="적용 요일">
          <b-row align-v="center" class="justify-content-start" no-gutters>
            <b-col md="auto">
              <b-form-radio-group v-model="settingValue.targetDaysType">
                <b-form-radio value="Everyday">매일</b-form-radio>
                <b-form-radio value="Weekday">주중</b-form-radio>
                <b-form-radio value="Weekend">주말</b-form-radio>
                <b-form-radio value="Custom">사용자 지정</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row align-v="center" class="justify-content-start mt-1" :hidden="settingValue.targetDaysType !== 'Custom'">
            <b-col md="auto">
              <b-form-checkbox v-model="settingValue.monday" :value='true' :unchecked-value="false">월</b-form-checkbox>
            </b-col>
            <b-col md="auto">
              <b-form-checkbox v-model="settingValue.tuesday" :value='true' :unchecked-value="false">화</b-form-checkbox>
            </b-col>
            <b-col md="auto">
              <b-form-checkbox v-model="settingValue.wednesday" :value='true' :unchecked-value="false">수
              </b-form-checkbox>
            </b-col>
            <b-form-checkbox v-model="settingValue.thursday" :value='true' :unchecked-value="false">목</b-form-checkbox>
            <b-col md="auto">
              <b-form-checkbox v-model="settingValue.friday" :value='true' :unchecked-value="false">금</b-form-checkbox>
            </b-col>
            <b-col md="auto">
              <b-form-checkbox v-model="settingValue.saturday" :value='true' :unchecked-value="false">토
              </b-form-checkbox>
            </b-col>
            <b-col md="auto">
              <b-form-checkbox v-model="settingValue.sunday" :value='true' :unchecked-value="false">일</b-form-checkbox>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group label-cols="3" horizontal label="시간대 단위 시간">
          <b-row align-v="center" class="justify-content-start" no-gutters>
            <b-col md="auto">
              <b-form-radio-group v-model="settingValue.inventoryTimeUnit" @change="onChangeTimeUnit">
                <b-form-radio value="M60">1시간</b-form-radio>
                <b-form-radio value="M30">30분</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group label-cols="3" horizontal label="예약 가능 시간">
          <b-row align-v="center" class="justify-content-start" no-gutters>
            <b-col cols="3">
              <b-form-select v-model="settingValue.startTime"
                             :options="settingValue.inventoryTimeUnit === 'M60'? m60Options: m30Options" plain/>
            </b-col>
            <b-col md="auto" class="ml-2">
              <span>~</span>
            </b-col>
            <b-col cols="3" class="ml-2">
              <b-form-select v-model="settingValue.endTime"
                             :options="settingValue.inventoryTimeUnit === 'M60'? m60Options: m30Options" plain/>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group label-cols="3" horizontal label="예약 가능 인원">
          <b-form-group label-cols="5" horizontal label="예약 건당 최소 예약 가능 인원" label-align="left" >
            <b-row align-v="center" class="justify-content-start ml-2" no-gutters>
              <b-col cols="3">
                <b-input-group size="sm">
                  <b-form-input v-model="settingValue.minimumBookHeadcount" size="sm" type="number" ></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group label-cols="5" horizontal label="예약 건당 최대 예약 가능 인원" label-align="left" >
            <b-row align-v="center" class="justify-content-start ml-2" no-gutters>
              <b-col cols="3">
                <b-input-group size="sm">
                  <b-form-input v-model="settingValue.maximumBookHeadcount" size="sm" type="number"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group label-cols="5" horizontal label="시간대 별로 총 예약 가능 인원" label-align="left">
            <b-row align-v="center" class="justify-content-start ml-2" no-gutters>
              <b-col cols="3">
                <b-input-group size="sm">
                  <b-form-input ref="atTimeBtn" :disabled="settingValue.useInventoryAtTimeUnits == true ? true : false" v-model="settingValue.totalHeadcount" @change="totalHeadcountHeadcount" size="sm" type="number"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </b-form-group>

            <b-col md="auto" no-gutters style="padding-left:0px;">
              <b-form-checkbox v-model="settingValue.useInventoryAtTimeUnits" :value='true' :unchecked-value='false'
                              @change="onChangeHeadcountPerTimeUnitCheckButton">
                시간대별로 총 예약 가능 인원을 다르게 설정하기
              </b-form-checkbox>
            </b-col>

        </b-form-group>

        <div :hidden="!settingValue.useInventoryAtTimeUnits" class="mt-2">
          <b-form-group label-cols="3" horizontal label="시간대 별 총 예약 가능 인원">
            <b-row align-v="center" class="justify-content-start" no-gutters>
              <b-col cols="7">
                <!-- {{ settingValue.headCountAtTimeUnits }} -->
                <b-table
                  id="table-headcount-per-timeunit"
                  :items="headcountByTimeUnits"
                  :fields="fields"
                  striped
                  small
                  fixed
                  primary-key="timeUnit"
                >
                  
                  <template v-slot:cell(headcount)="row">
                    <!-- {{row.item}} -->
                    <b-row align-v="center" class="p-0 m-0" no-gutters>
                      <b-input-group size="sm">
                        <b-input v-model="row.item.headCount" type="number" @change="changeinventoryTime">
                        </b-input>
                      </b-input-group>
                    </b-row>
                  </template>

                </b-table>
              </b-col>
            </b-row>
          </b-form-group>
        </div>

      </b-colxx>
    </b-row>
  </div>
</template>

<script>

  export default {
    props: ['settingValue'],
    data() {
      return {
        always: false,
        countIndex:0,
        newHeadCountArray:[],
        dayOfWeek: [
          {text: '월', value: 'monday'},
          {text: '화', value: 'tuesday'},
          {text: '수', value: 'wednesday'},
          {text: '목', value: 'thursday'},
          {text: '금', value: 'friday'},
          {text: '토', value: 'saturday'},
          {text: '일', value: 'sunday'}
        ],
        mOptions: [
          {value: '00:00', hour: '00',ahalf:false,headcount:0,text: '00시 00분'},
          {value: '00:30', hour: '00',ahalf:true,headcount:0,text: '00시 30분'},
          {value: '01:00', hour: '01',ahalf:false,headcount:0,text: '01시 00분'},
          {value: '01:30', hour: '01',ahalf:true,headcount:0,text: '01시 30분'},
          {value: '02:00', hour: '02',ahalf:false,headcount:0,text: '02시 00분'},
          {value: '02:30', hour: '02',ahalf:true,headcount:0,text: '02시 30분'},
          {value: '03:00', hour: '03',ahalf:false,headcount:0,text: '03시 00분'},
          {value: '03:30', hour: '03',ahalf:true,headcount:0,text: '03시 30분'},
          {value: '04:00', hour: '04',ahalf:false,headcount:0,text: '04시 00분'},
          {value: '04:30', hour: '04',ahalf:true,headcount:0,text: '04시 30분'},
          {value: '05:00', hour: '05',ahalf:false,headcount:0,text: '05시 00분'},
          {value: '05:30', hour: '05',ahalf:true,headcount:0,text: '05시 30분'},
          {value: '06:00', hour: '06',ahalf:false,headcount:0,text: '06시 00분'},
          {value: '06:30', hour: '06',ahalf:true,headcount:0,text: '06시 30분'},
          {value: '07:00', hour: '07',ahalf:false,headcount:0,text: '07시 00분'},
          {value: '07:30', hour: '07',ahalf:true,headcount:0,text: '07시 30분'},
          {value: '08:00', hour: '08',ahalf:false,headcount:0,text: '08시 00분'},
          {value: '08:30', hour: '08',ahalf:true,headcount:0,text: '08시 30분'},
          {value: '09:00', hour: '09',ahalf:false,headcount:0,text: '09시 00분'},
          {value: '09:30', hour: '09',ahalf:true,headcount:0,text: '09시 30분'},
          {value: '10:00', hour: '10',ahalf:false,headcount:0,text: '10시 00분'},
          {value: '10:30', hour: '10',ahalf:true,headcount:0,text: '10시 30분'},
          {value: '11:00', hour: '11',ahalf:false,headcount:0,text: '11시 00분'},
          {value: '11:30', hour: '11',ahalf:true,headcount:0,text: '11시 30분'},
          {value: '12:00', hour: '12',ahalf:false,headcount:0,text: '12시 00분'},
          {value: '12:30', hour: '12',ahalf:true,headcount:0,text: '12시 30분'},
          {value: '13:00', hour: '13',ahalf:false,headcount:0,text: '13시 00분'},
          {value: '13:30', hour: '13',ahalf:true,headcount:0,text: '13시 30분'},
          {value: '14:00', hour: '14',ahalf:false,headcount:0,text: '14시 00분'},
          {value: '14:30', hour: '14',ahalf:true,headcount:0,text: '14시 30분'},
          {value: '15:00', hour: '15',ahalf:false,headcount:0,text: '15시 00분'},
          {value: '15:30', hour: '15',ahalf:true,headcount:0,text: '15시 30분'},
          {value: '16:00', hour: '16',ahalf:false,headcount:0,text: '16시 00분'},
          {value: '16:30', hour: '16',ahalf:true,headcount:0,text: '16시 30분'},
          {value: '17:00', hour: '17',ahalf:false,headcount:0,text: '17시 00분'},
          {value: '17:30', hour: '17',ahalf:true,headcount:0,text: '17시 30분'},
          {value: '18:00', hour: '18',ahalf:false,headcount:0,text: '18시 00분'},
          {value: '18:30', hour: '18',ahalf:true,headcount:0,text: '18시 30분'},
          {value: '19:00', hour: '19',ahalf:false,headcount:0,text: '19시 00분'},
          {value: '19:30', hour: '19',ahalf:true,headcount:0,text: '19시 30분'},
          {value: '20:00', hour: '20',ahalf:false,headcount:0,text: '20시 00분'},
          {value: '20:30', hour: '20',ahalf:true,headcount:0,text: '20시 30분'},
          {value: '21:00', hour: '21',ahalf:false,headcount:0,text: '21시 00분'},
          {value: '21:30', hour: '21',ahalf:true,headcount:0,text: '21시 30분'},
          {value: '22:00', hour: '22',ahalf:false,headcount:0,text: '22시 00분'},
          {value: '22:30', hour: '22',ahalf:true,headcount:0,text: '22시 30분'},
          {value: '23:00', hour: '23',ahalf:false,headcount:0,text: '23시 00분'},
          {value: '23:30', hour: '23',ahalf:true,headcount:0,text: '23시 30분'},
        ],
        m60Options: [
          {value: null, text: '--시--', disabled: true},
          {value: '00:00', text: '00 시'},
          {value: '01:00', text: '01 시'},
          {value: '02:00', text: '02 시'},
          {value: '03:00', text: '03 시'},
          {value: '04:00', text: '04 시'},
          {value: '05:00', text: '05 시'},
          {value: '06:00', text: '06 시'},
          {value: '07:00', text: '07 시'},
          {value: '08:00', text: '08 시'},
          {value: '09:00', text: '09 시'},
          {value: '10:00', text: '10 시'},
          {value: '11:00', text: '11 시'},
          {value: '12:00', text: '12 시'},
          {value: '13:00', text: '13 시'},
          {value: '14:00', text: '14 시'},
          {value: '15:00', text: '15 시'},
          {value: '16:00', text: '16 시'},
          {value: '17:00', text: '17 시'},
          {value: '18:00', text: '18 시'},
          {value: '19:00', text: '19 시'},
          {value: '20:00', text: '20 시'},
          {value: '21:00', text: '21 시'},
          {value: '22:00', text: '22 시'},
          {value: '23:00', text: '23 시'},
        ],
        m30Options: [
          {value: null, text: '--시--', disabled: true},
          {value: '00:00', text: '00시 00분'},
          {value: '00:30', text: '00시 30분'},
          {value: '01:00', text: '01시 00분'},
          {value: '01:30', text: '01시 30분'},
          {value: '02:00', text: '02시 00분'},
          {value: '02:30', text: '02시 30분'},
          {value: '03:00', text: '03시 00분'},
          {value: '03:30', text: '03시 30분'},
          {value: '04:00', text: '04시 00분'},
          {value: '04:30', text: '04시 30분'},
          {value: '05:00', text: '05시 00분'},
          {value: '05:30', text: '05시 30분'},
          {value: '06:00', text: '06시 00분'},
          {value: '06:30', text: '06시 30분'},
          {value: '07:00', text: '07시 00분'},
          {value: '07:30', text: '07시 30분'},
          {value: '08:00', text: '08시 00분'},
          {value: '08:30', text: '08시 30분'},
          {value: '09:00', text: '09시 00분'},
          {value: '09:30', text: '09시 30분'},
          {value: '10:00', text: '10시 00분'},
          {value: '10:30', text: '10시 30분'},
          {value: '11:00', text: '11시 00분'},
          {value: '11:30', text: '11시 30분'},
          {value: '12:00', text: '12시 00분'},
          {value: '12:30', text: '12시 30분'},
          {value: '13:00', text: '13시 00분'},
          {value: '13:30', text: '13시 30분'},
          {value: '14:00', text: '14시 00분'},
          {value: '14:30', text: '14시 30분'},
          {value: '15:00', text: '15시 00분'},
          {value: '15:30', text: '15시 30분'},
          {value: '16:00', text: '16시 00분'},
          {value: '16:30', text: '16시 30분'},
          {value: '17:00', text: '17시 00분'},
          {value: '17:30', text: '17시 30분'},
          {value: '18:00', text: '18시 00분'},
          {value: '18:30', text: '18시 30분'},
          {value: '19:00', text: '19시 00분'},
          {value: '19:30', text: '19시 30분'},
          {value: '20:00', text: '20시 00분'},
          {value: '20:30', text: '20시 30분'},
          {value: '21:00', text: '21시 00분'},
          {value: '21:30', text: '21시 30분'},
          {value: '22:00', text: '22시 00분'},
          {value: '22:30', text: '22시 30분'},
          {value: '23:00', text: '23시 00분'},
          {value: '23:30', text: '23시 30분'},
        ],
        fields: [
          {key: 'timeUnit', label: "시간대"},
          {key: 'headcount', label: "총 예약 가능 인원수"},
        ]
      }
    },

    mounted() {
      // console.log(this.settingValue)
      // console.log(this.settingValue.startDate);
      // this.settingValue.startDate = this.$moment(this.settingValue.startDate).toDate();
      // console.log(this.settingValue.startDate)
      if(this.settingValue.useInventoryAtTimeUnits == true){
          // console.log()
          this.$refs.atTimeBtn.disabled = true
        }else{
          this.$refs.atTimeBtn.disabled = false
        }
      //헤드카운트 api 프로퍼티 가져오기
      let vm = this;
     this.mOptions.forEach((el,idx) => {
                vm.settingValue.headCountAtTimeUnitsCopy.find((fifi) => {
                    if(Number(fifi.hour) === Number(el.hour) && fifi.ahalf == false && fifi.ahalf == el.ahalf){
                      el.headcount = fifi.headCount;
                    }else if(Number(fifi.hour) === Number(el.hour) && fifi.ahalf == el.ahalf ){
                      el.headcount = fifi.headCount;
                    }
                })
              });

      // console.log(this.mOptions)
      this.buildTimeUnitHeadcountItems();
      
      if(this.settingValue.startDate == null && this.settingValue.endDate == null) {
        this.always = "true"
      }else{
        this.always = "false"
      }
      this.onChangeHeadcountPerTimeUnitCheckButton(this.settingValue.settinguseInventoryAtTimeUnits)
    },


    methods: {
      changeMbhc(e,kind){
          // if(kind === true){
          //   if(Number(this.settingValue.totalHeadcount) < Number(this.settingValue.minimumBookHeadcount)){
          //     alert('최소 예약 가능 인원은 총 예약 가능 인원보다 클 수 없습니다.');
          //     this.settingValue.minimumBookHeadcount = 0;
          //   }
          // }else{
          //   if(Number(this.settingValue.totalHeadcount) < Number(this.settingValue.maximumBookHeadcount)){
          //     alert('최대 예약 가능 인원은 총 예약 가능 인원보다 클 수 없습니다.');
          //     this.settingValue.maximumBookHeadcount = 0;
          //   }
          // }
          // return;
      },
      changeinventoryTime(val){
      
        if(val === true){
          // console.log(this.settingValue.headCountAtTimeUnits)
          if(this.settingValue.headCountAtTimeUnitsCopy.length == 0){
            this.mOptions.forEach((el,idx) => {
              el.headcount = this.settingValue.totalHeadcount;
            });
          }
          let vm = this;
          this.mOptions.forEach((el,idx) => {
              vm.headcountByTimeUnits.find((fifi) => {
                  if(Number(fifi.hour) === Number(el.hour) && fifi.ahalf == false && fifi.ahalf == el.ahalf){
                    el.headcount = fifi.headCount;
                  }else if(Number(fifi.hour) === Number(el.hour) && fifi.ahalf == el.ahalf ){
                    el.headcount = fifi.headCount;
                  }
              })
            });
        }
      },
      buildTimeUnitHeadcountItems: function() {

        let vm = this
        let startHour = vm.settingValue.startTime
        let endHour = vm.settingValue.endTime
        let totalHeadcount = vm.settingValue.totalHeadcount
        vm.settingValue.headCountAtTimeUnits = []
        // console.log(vm.settingValue.headCountAtTimeUnits)
        if(startHour === null || startHour === "" || endHour === null || endHour === "") {
          return;
        }
        if(this.settingValue.inventoryTimeUnit === 'M60') {
          this.mOptions.forEach(function(option) {
            if(option.value >= startHour && option.value <= endHour && option.ahalf == false) {
              vm.settingValue.headCountAtTimeUnits.push({
                key: option.value,
                hour: option.value.substring(0, 2),
                ahalf: false,
                timeUnit: option.text,
                headCount: option.headcount
              })
            }
          });
        } else {
          this.mOptions.forEach(function(option) {
            if(option.value >= startHour && option.value <= endHour) {
              let ahalf = option.value.substring(3, 5) === "30" ? true : false
              vm.settingValue.headCountAtTimeUnits.push({
                key: option.value,
                hour: option.value.substring(0, 2),
                ahalf: ahalf,
                timeUnit: option.text,
                headCount: option.headcount,
              })
              // console.log(option.value.substring(3, 5))
            }
          });
          
        }

      },
      totalHeadcountHeadcount(){
        
        this.mOptions.forEach((el,idx) => {
          el.headcount =  this.settingValue.totalHeadcount;
        });
      },
      onChangeHeadcountPerTimeUnitCheckButton(val) {
        if(val !== true) {
          return;
        }
        // console.log(this.settingValue.useInventoryAtTimeUnits)
        if(this.settingValue.useInventoryAtTimeUnits == true){
          this.$refs.atTimeBtn.disabled = true
        }else{
          this.$refs.atTimeBtn.disabled = false
        }
        this.buildTimeUnitHeadcountItems();
        this.changeinventoryTime(val);
        // console.log(val)
      },

      onChangeTimeUnit() {
        this.settingValue.startTime = null;
        this.settingValue.endTime = null;
        this.changeinventoryTime();
      },

    },//method

    computed:{
       headcountByTimeUnits(){
          let starthours = this.settingValue.startTime
          let endHour = this.settingValue.endTime
          let vm = this;
          vm.settingValue.headCountAtTimeUnits = [];
          //인원수 새로운 배열에 담기
          vm.mOptions.forEach(function(option,idx) {
              if(vm.settingValue.inventoryTimeUnit === "M60"){
                //배열안에 시간이 시작시간보다 크거나 같을떄 끝나는 시간보다는 작은시간 옵션 ahalf 가 false 이면 1시간 배열 넣기
                if(option.value >= starthours && option.value <= endHour && option.ahalf == false){
                  let ahalf = option.value.substring(3, 5) === "30" ? true : false;
                  vm.settingValue.headCountAtTimeUnits.push({
                    key: option.value,
                    hour: option.value.substring(0, 2),
                    ahalf: ahalf,
                    timeUnit: option.text,
                    headCount: option.headcount
                  })
                  // vm.settingValue.headCountAtTimeUnits.push({hour:option.value.substring(0, 2),ahalf:ahalf,headcount:option.headcount});
                }
              }else{
                //30분일경우 전체 배열에 넣기
                if(option.value >= starthours && option.value <= endHour) {
                  let ahalf = option.value.substring(3, 5) === "30" ? true : false
                  vm.settingValue.headCountAtTimeUnits.push({
                    key: option.value,
                    hour: option.value.substring(0, 2),
                    ahalf: ahalf,
                    timeUnit: option.text,
                    headCount: option.headcount,
                  })
                }
              }
            });
          return vm.settingValue.headCountAtTimeUnits;
       }
    },

    watch: {

      always() {
        this.$emit("alwaysIs",this.always)
        // console.log('watch : ', this.always)
      },

      'settingValue.startTime': function(newValue, oldValue) {
        if(!this.settingValue.useInventoryAtTimeUnits) {
          return;
        }
        this.buildTimeUnitHeadcountItems();
      },
      'settingValue.targetDaysType': function(newValue, oldValue) {
        if(newValue !== 'Custom') {
          this.settingValue.monday = false;
          this.settingValue.tuesday = false;
          this.settingValue.wednesday = false;
          this.settingValue.thursday = false;
          this.settingValue.friday = false;
          this.settingValue.saturday = false;
          this.settingValue.sunday = false;
        }
      },
      'settingValue.endTime': function(newValue, oldValue) {
        if(!this.settingValue.useInventoryAtTimeUnits) {
          return;
        }
        this.buildTimeUnitHeadcountItems();
      },
      'settingValue.headCountAtTimeUnitsCopy': function(){
        // console.log('변경감지');
        let vm = this;
        this.settingValue.headCountAtTimeUnitsCopy = this.settingValue.headCountAtTimeUnits;
        this.mOptions.forEach((el,idx) => {
                vm.settingValue.headCountAtTimeUnits.find((fifi) => {
                    if(Number(fifi.hour) === Number(el.hour) && fifi.ahalf == false && fifi.ahalf == el.ahalf){
                      el.headcount = fifi.headCount;
                    }else if(Number(fifi.hour) === Number(el.hour) && fifi.ahalf == el.ahalf ){
                      el.headcount = fifi.headCount;
                    }
                })
              });
        // console.log(this.mOptions)
      }


    }
  }
</script>

<style scoped>
  .table > tbody > tr > td {
    vertical-align: middle;
    horiz-align: center;
    text-align: center;
  }
</style>
